import {
    CountryValidationConfig,
    shouldValidateForCountry
} from './country-validation';

const error = 'commons.validation.required';

export const required = <T = unknown>(
    countryConfig?: CountryValidationConfig
) => (value: T) => {
    if (!shouldValidateForCountry(countryConfig)) {
        return false;
    }

    if (typeof value === 'number') {
        return isNaN(value) ? error : false;
    }

    return value ? false : error;
};
